import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { makeStyles, IconButton } from '@applyboard/ui-components';
import { CloseDialogIcon } from "../../../../assets/images";
var useStyles = makeStyles({
  closeButton: {
    '&.MuiIconButton-root': {
      "float": 'right',
      padding: 0
    }
  }
});
var CloseButton = function CloseButton(_ref) {
  var onClick = _ref.onClick;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close dialog",
    className: classes.closeButton,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(CloseDialogIcon, null)));
};
export default CloseButton;